<template>
  <ScrollArea>
    <div
      class="settings--limit-width">
      <h1 class="settings__title">Email address</h1>

      <div
        class="settings--box big" >
        <ValidationObserver
          ref="customFieldObserver"
          v-slot="{ valid, dirty, pristine }" >

          <b-form-group>
            <label class="flex flex-align-center">
              Email address
            </label>
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|email"
              name="Email address" >
              <b-input
                v-model="emailModel"
                autocomplete="off"
                class="sb2-bordered sb2-hoverable sb2-focusable"
                placeholder="Enter your email address" />
              <div
                v-if="errors[0] || responseError"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>{{ errors[0] || responseError }}</span>
              </div>
            </ValidationProvider>
          </b-form-group>

          <FooterActions
            :form-valid="valid"
            :has-changes="dirty"
            :show-cancel="!pristine"
            :save-busy="saving"
            @reset="resetChanges"
            @save="confirmChange" />
        </ValidationObserver>
      </div>

    </div>
  </ScrollArea>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ScrollArea from '@/components/common/ScrollArea';
import ToasterMixin from '@/mixins/Toaster';
import FooterActions from '@/components/business/settings/partials/FooterActions';
import NoPermissionMixin from '@/mixins/AccessPermission';

export default {
  name: 'Email',
  components: {
    FooterActions,
    ScrollArea,
  },
  mixins: [
    ToasterMixin,
    NoPermissionMixin,
  ],
  data() {
    return {
      saving: false,
      newEmail: null,
      responseError: '',
    };
  },
  computed: {
    ...mapGetters({
      email: 'user/email',
      apiError: 'automation/apiError',
    }),
    emailModel: {
      get() {
        let returnValue;
        if (this.newEmail) {
          returnValue = this.newEmail;
        }
        return returnValue;
      },
      set(changedContent) {
        this.newEmail = changedContent;
        this.resetValidator();
      },
    },
    noMatch() {
      return this.newPasswordModel !== this.newPasswordConfirmModel;
    },
  },
  watch: {
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.showToaster(error.data.errors, null, null, 'error');
      } else {
        this.showToaster(error.message || 'Something went wrong. Please try again.', null, null, 'error');
      }
    },
    email() {
      this.emailModel = this.email;
    },
  },
  mounted() {
    if (this.email) {
      this.emailModel = this.email;
    }
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
      updateMemberEmail: 'user/updateMemberEmail',
    }),
    resetChanges() {
      this.emailModel = this.email;
    },
    confirmChange() {
      this.$passwordConfirmPluginModal.show({
        confirmCallback: this.updateNotificationSettings,
      });
    },
    updateNotificationSettings() {
      this.saving = true;
      const payload = {
        email: this.emailModel,
      };

      this.updateMemberEmail(payload)
        .then((response) => {
          if (response.status === 200) {
            this.showToaster('Your email has been successfully updated.', null, null, 'OK');
          }
        })
        .catch((response) => {
          if (response.response.status === 403) {
            this.responseError = response.response.data.message;
          } else {
            this.showToaster('There was an error. Please try again later.', null, null, 'warning');
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    resetValidator() {
      // Reset the validator if message edit was undone
      if (
        this.email === this.newEmail
      ) {
        this.$nextTick(() => { this.$refs.customFieldObserver.reset(); });
      }
      this.responseError = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-icon {
  margin-bottom: 15px;
}

::v-deep .text-input-component .text-input-wrapper {
    max-height: unset;

    .input-scroll-area {
      height: unset;
      min-height: 72px;
      max-height: calc(100vh - 400px);
    }
}
</style>
